import React from "react";
export const Private = () => {

     return (
          <div className="page">
               <h2>Members area</h2>
               <p>This is the private members area</p>
          </div>
     )
}